export default __webpack_public_path__ + "static/media/tiktok.22d856a3.svg";